<template lang="pug">
  .layout-view
    .layout-view__controls
      v-btn(
        medium
        @click="openCreateModal")
        v-icon(
          position-left
          font-size="1"
          icon="plus")
        | {{ 'base.add_user' | translate }}
    table.table.table--bars
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          th.table__cell {{ 'base.email' | translate }}
          th.table__cell {{ 'base.groups' | translate }}
          th.table__cell {{ 'base.farms' | translate }}
          th.table__cell
      v-table-body(
        :cols="5"
        :loading="!loaded"
        :empty="!employees.length")
        template(v-slot="{ isToggled, toggleRow }")
          template(v-for="item in employees")

            //- TABLE ROW
            tr.table__row(:class="{ 'table__row--merge-bottom': isToggled(item) }")
              td.table__cell {{ `${item.first_name} ${item.last_name}` }}
              td.table__cell {{ item.email }}
              td.table__cell {{ item.groups.length }}
              td.table__cell {{ item.farms.length }}
              td.table__cell.table__cell--action
                actions-dropdown.mr-2.flex(
                  @edit="openEditModal(item)"
                  @delete="deleteEmployee(item)"
                  @change-password="openChangePasswordModal(item)")
                v-btn(
                  icon
                  @click="toggleRow(item)")
                  v-chevron(:value="isToggled(item)")
            
            //- TABLE ROW EXTENDED
            tr.table__row.table__row--merge-top(
              v-if="isToggled(item)")
              td.table__cell.p-0.vertical-align-baseline(
                colspan="2")
                table.table
                  thead
                    tr.table__row.table__row--head
                      th.table__cell {{ 'base.groups' | translate }}
                  tbody
                    tr.table__row(
                      v-for="item in item.groups"
                      :key="item.id")
                      th.table__cell {{ item.name }}
              td.table__cell.p-0.vertical-align-baseline(
                colspan="3")
                table.table
                  thead
                    tr.table__row.table__row--head
                      th.table__cell {{ 'base.farms' | translate }}
                  tbody
                    tr.table__row(
                      v-for="item in item.farms"
                      :key="item.id")
                      td.table__cell {{ item.name }}
    
    //- DETAIL MODAL
    v-dialog(
      max-width="740"
      v-model="modals.detail")
      detail-modal(
        :key="modalKey"
        :selected="selectedItem"
        @close="closeDetailModal")

    //- CHANGE PASSWORD MODAL
    v-dialog(
      max-width="400"
      v-model="modals.changePassword")
        change-password(
          @submit="onPasswordChange")
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'

import ChangePassword from '@/components/common/change-password/ChangePassword'

import DetailModal from './DetailModal'
import ActionsDropdown from './ActionsDropdown'

export default {
  name: 'Users',

  components: {
    ChangePassword,
    DetailModal,
    ActionsDropdown
  },

  mounted () {
    this.loadData()
  },

  data: () => ({
    modals: {
      detail: false,
      changePassword: false
    },
    selectedId: null,
    loaded: false,
    modalKey: 0
  }),

  computed: {
    ...mapGetters('employees', [
      'employees'
    ]),

    selectedItem () {
      return this.employees
        .find(item => item.id === this.selectedId)
    }
  },

  methods: {
    ...mapActions('employees', [
      'loadEmployees',
      'deleteEmployee'
    ]),

    openCreateModal () {
      this.selectedId = null
      this.modalKey++
      this.modals.detail = true
    },

    openEditModal (item) {
      this.selectedId = item.id
      this.modalKey++
      this.modals.detail = true
    },

    openChangePasswordModal (item) {
      this.selectedId = item.id
      this.modals.changePassword = true
    },

    closeDetailModal () {
      this.modals.detail = false
      this.selectedId = null
    },

    async loadData () {
      this.loaded = false
      const { data } = await api.account.get()

      if (data.user_type !== 'employee') {
        await this.loadEmployees()
      }
      this.loaded = true
    },

    async onPasswordChange (payload) {
      if (this.selectedId) {
        const { errors } = await api.employees.updatePassword(this.selectedId, payload)
        if (!errors) {
          this.modals.changePassword = false
        } else {
          this.$toasted.error(this.$t('errors.bad_data'))
        }
      }
    }
  }
}
</script>
<style scoped>
.table__cell--action {
  display: flex;
}
</style>